<template>
  <div class="ecl-form-group">
    <label for="example-input-id-1" class="ecl-form-label" v-if="label">{{label}}</label>
    <input
        :type="type"
        class="ecl-text-input"
        :class="{'ecl-u-border-color-red': !!error}"
        :placeholder="placeholder"
        @input="handleInput"
        @blur="validate"
    />
    <span class="validation-error" v-if="error">
      {{ error }}
    </span>
  </div>
</template>

<script>
export default {
  name: "ECInput",
  props: {
    label: String,
    value: [String, Number],
    placeholder: String,
    type: {
      type: String,
      default: "text"
    },
    validation: Function
  },
  data() {
    return {
      content: this.value,
      error: false
    };
  },
  methods: {
    handleInput(event) {
      this.content = event.target.value;
      this.$emit('input', this.content);
      this.error = false;
    },
    validate() {
      this.error = this.validation(this.content);
      return this.error;
    }
  }
}
</script>

<style lang="scss" scoped>
  .validation-error {
    color: crimson;
  }
  .ecl-text-input {
    width: 100%;
  }
</style>
